<template>
  <div>
    <div class="home-banners-box carousel slide" data-ride="carousel" id="hpBannerCarousel" role="region">
      <div class="carousel-inner" v-if="images.homeBanners.length > 0">
        <div class="item" v-for="(banner, index) in images.homeBanners" :key="index" :class="[index === 0 ? activeClass: '']">
          <img :src="banner">
        </div>
      </div>
      <div class="carousel-inner" v-else>
        <div class="item" v-for="(preview, index) in component.previews" :key="preview.index" :class="[index === 0 ? activeClass: '']">
          <img class="img-responsive" :src="preview.image">
        </div>
      </div>
      <a class="left carousel-control" href="#hpBannerCarousel" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#hpBannerCarousel" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 'images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active'
    };
  },
  mounted() {
    (function() {
      
      var c = {
        init: function() {
          $('#hpBannerCarousel').carousel({
            interval: 5000
            })
        }
      }
      $(document).ready(c.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .home-banners-box {
    cursor: pointer;
  }
  #hpBannerCarousel .carousel-control {
    width: 5%;
  }
  #hpBannerCarousel .item {
    width: 100% !important;
  }
  #hpBannerCarousel .item img {
    display: block;
    width: 100% !important;
    height: auto !important;
  }
</style>
